var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import-popup"},[_vm._v(" This Is Import ")])}
var staticRenderFns = []

export { render, staticRenderFns }